module.exports = __webpack_public_path__ + "static/media/huawei_recent_3.c486a8d8.png";